module.exports = __webpack_public_path__ + "img/icon-check.149bfdb8.svg";